if ( $('section#releases').length || $('section#all-publications').length) {
  $(function(){
    $('#special-page').css('background-color', '#F2F2F5');
  });
}
